import { useCallback, memo } from 'react';
import { useHistory } from 'react-router';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { StarEyesEmoji } from '../../assets/icons/emojis';
import useCommonStyles from '../../styles/common';

interface Props {
  handleClose: () => void;
  reservationId?: number;
  type?: 'reservation' | 'app'
}

const ThanksForm = (props: Props) => {
  const { reservationId, handleClose, type = 'reservation' } = props;
  const { push, location } = useHistory();
  const classes = useStyles();
  const commonClasses = useCommonStyles();

  const handleCloseFinished = useCallback(() => {
    if (location.pathname.includes('meu-agendamento')) handleClose();
    else push(`/meu-agendamento/${reservationId}`);
  }, [location, handleClose, push, reservationId]);

  return (
    <Box className={classes.thanksDialog}>
      <img src={StarEyesEmoji} alt="star-eyes-emoji" draggable="false" />
      <DialogTitle
        id="simple-dialog-title"
        className={classes.title}
      >
        Agradecemos por sua avaliação!
      </DialogTitle>
      <DialogActions className={classes.actions}>
        <Button
          variant="outlined"
          onClick={type === 'reservation' ? handleCloseFinished : handleClose}
          className={commonClasses.outlinedButton}
        >
          Fechar
        </Button>
      </DialogActions>
    </Box>
  );
}

export default memo(ThanksForm);

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    thanksDialog: {
      minHeight: 250,
      padding: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      alignItems: 'center',

      '& img': {
        width: '100%',
        maxWidth: 80,
      }
    },
    title: {
      '& h2': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(22),
        fontWeight: theme.typography.fontWeightBold,
      }
    },
    actions: {
      marginTop: theme.spacing(3),
      alignItems: 'flex-end',
      justifyContent: 'center',

      '& > #feedback-button': {
        marginTop: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
          marginTop: 'unset',
        }
      },

      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
        alignItems: 'flex-end'
      }
    },
  })
);